export default {
  SPOT_TYPE_SHRINE: 0,
  SPOT_TYPE_TEMPLE: 1,
  SPOT_TYPE_OTHER: 9,
};
